import { clamp } from '../lib/math'
import Lightbox, { type ContentItem } from './Lightbox'

// The exporting class.
export default class Slider {
	// Keep a list of *all* sliders.
	static readonly #sliderList = new WeakMap<HTMLElement, Slider>()

	static {
		addEventListener('DOMContentLoaded', () => {
			const elements = document.getElementsByClassName('image-slider') as HTMLCollectionOf<HTMLElement>

			for (let a = 0; a < elements.length; a++) {
				this.#sliderList.set(elements[a], new Slider(elements[a]))
			}
		})
	}

	#timeout: number
	public intervalDuration = 0 // ms. 0 = no interval.
	public currentIndex: number
	public readonly dots: HTMLElement[]
	public readonly images: HTMLElement[]

	//

	public constructor(public readonly element: HTMLElement) {
		if (Slider.#sliderList.has(element)) {
			return Slider.#sliderList.get(element)
		}

		this.element = element

		this.currentIndex = 0

		this.images = Array.from(this.element.querySelectorAll('.image'))
		this.dots = Array.from(this.element.querySelectorAll('.dots .dot'))

		// Steppers.
		this.element.querySelector('.stepper.next')?.addEventListener('click', (event) => {
			event.preventDefault()
			this.setIndex(this.currentIndex + 1)
		}, true)

		this.element.querySelector('.stepper.previous')?.addEventListener('click', (event) => {
			event.preventDefault()
			this.setIndex(this.currentIndex - 1)
		}, true)

		// Fullscreen/lightbox mode
		this.element.querySelector('.fullscreen')?.addEventListener('click', (event) => {
			this.onImageClick(this.currentIndex)
		})

		for (let a = 0; a < this.images.length; a++) {
			const index = a
			this.dots[a].addEventListener('click', () => this.setIndex(index))
		}

		// Force initialization.
		this.setIndex(0)
	}

	public setIndex(index: number) {
		index = clamp(index, 0, this.images.length - 1)

		this.element.classList.toggle('first', index == 0)
		this.element.classList.toggle('last', index == (this.images.length - 1))

		if (this.images.length > 0) {
			for (let a = 0; a < this.images.length; a++) {
				const offset = a - index
				this.images[a].classList.toggle('active', a === index)
				this.images[a].dataset.offset = `${offset}`
				this.dots[a].classList.toggle('active', a === index)
			}
		}

		this.currentIndex = index
		this.setTimeout()
	}

	private onImageClick(index: number) {
		const images: ContentItem[] = []
		for (let a = 0; a < this.images.length; a++) {
			images.push({
				src: this.images[a].dataset.lbImage,
				title: this.images[a].dataset.lbTitle,
			})
		}

		Lightbox.open(images, index)
	}

	private setTimeout() {
		clearTimeout(this.#timeout)

		if (this.intervalDuration > 0) {
			this.#timeout = setTimeout(() => {
				const nextIndex = (this.currentIndex + 1) % this.images.length
				this.setIndex(nextIndex)
			}, this.intervalDuration)
		}
	}
}